import Vue from 'vue';
import moment from 'moment';

const success = ({ data }, resolve) => {
  resolve(data);
};

const failed = (error, reject) => reject(error);


export default (dateRange, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/infinitum';
    const query = [];

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (dateRange) {
      query.push(`month=${moment(dateRange).format('YYYY-MM-DD')}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/infinitum.js